import { PropertyType } from '../../../common';

export const mapApiToEntity = (data: PropertyType): PropertyType => ({
	uid: data.uid,
	token: data.sid,
	tokenExpiration: data.sid_expiration,
});
